import React from 'react'

const ExperienceList = ({
    at,
    end,
    img,
    title,
    desc,
    company,
    type,
    link
}) => {
    return <div class="p-5 mb-4 bg-light rounded-lg border text-dark ">
        <time class="md:text-lg text-sm font-semibold ">{at} <i class="fa-solid fa-arrow-right text-sm mx-3"></i> {end}</time>
        <ol class="mt-3 divide-y divider-gray-200 ">
            <li>
                <div class="block items-center p-3 sm:flex">
                    <img class="mr-3 mb-3 md:w-24 md:h-24 w-10 h-10 rounded-full sm:mb-0" src={img} />
                    <div class="">
                        <div class="text-base font-semibold"><span class="font-medium ">{title}</span></div>
                        <div class="text-xs md:text-sm my-2 md:my-0 font-normal">"{desc}"</div>
                        <span class="flex mt-3 flex-col md:flex-row md:items-center text-xs font-normal gap-x-5 gap-y-3 md:gap-y-0">
                            <div className='flex gap-x-1 items-center'>
                                <i class="fa-solid fa-building"></i>
                                {company}
                            </div>
                            <div className='flex  items-center'>
                                <svg class="mr-1 w-3 h-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z" clip-rule="evenodd"></path></svg>
                                {type}
                            </div>
                            {link && <a href={link} target="_blank" className='flex gap-x-1 items-center'>
                                <i class="fa-solid fa-certificate"></i>
                                <span>certificate</span>
                            </a>}

                        </span>
                    </div>
                </div>
            </li>

        </ol>
    </div>
}

export default ExperienceList